/* main.js — NatPat Travel Kit — vanilla JS */
(function () {
  "use strict";

  /* ── FAQ Accordion ────────────────────────────────────────────────── */
  var accordionButtons = document.querySelectorAll(
    '[data-slot="accordion-trigger"]'
  );

  accordionButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var isOpen = btn.getAttribute("aria-expanded") === "true";
      var contentId = btn.getAttribute("aria-controls");
      var content = document.getElementById(contentId);
      // The accordion item is the closest ancestor with data-slot="accordion-item"
      var item = btn.closest('[data-slot="accordion-item"]');

      // Close all other accordion items first
      accordionButtons.forEach(function (other) {
        if (other === btn) return;
        var otherId = other.getAttribute("aria-controls");
        var otherContent = document.getElementById(otherId);
        var otherItem = other.closest('[data-slot="accordion-item"]');

        other.setAttribute("aria-expanded", "false");
        other.setAttribute("data-state", "closed");
        if (otherContent) otherContent.setAttribute("data-state", "closed");
        if (otherItem) otherItem.setAttribute("data-state", "closed");
      });

      // Toggle clicked item
      var newState = isOpen ? "closed" : "open";
      btn.setAttribute("aria-expanded", String(!isOpen));
      btn.setAttribute("data-state", newState);
      if (content) content.setAttribute("data-state", newState);
      if (item) item.setAttribute("data-state", newState);
    });
  });

  /* ── Smooth scroll for anchor links ──────────────────────────────── */
  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute("href");
    if (hash === "#") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    var target = document.querySelector(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  /* ── Sticky bottom CTA bar ───────────────────────────────────────── */
  var stickyBar = document.getElementById("sticky-cta");
  if (stickyBar) {
    var SCROLL_THRESHOLD = 300;
    function updateStickyBar() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        stickyBar.classList.add("visible");
      } else {
        stickyBar.classList.remove("visible");
      }
    }
    window.addEventListener("scroll", updateStickyBar, { passive: true });
    updateStickyBar();
  }
})();
